angular
	.module 'App.Module.CurrencyConversionRates', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'currency_conversion_rates',
				url: '/currency_conversion_rates',
				views:
					'main':
						controller: 'CurrencyConversionRateController'
						controllerAs: 'vm'
						templateUrl: '@app/currency-conversion-rate/currency-conversion-rate.view.html'
				data:
					restrict: 'POS.Payment.CurrencyConversionButton.Enabled'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					conversionRates: (CurrencyConversionRatesRepository) ->
						return CurrencyConversionRatesRepository.getEntities()
